
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/faqs/[key]",
      function () {
        return require("private-next-pages/help/faqs/[key].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/faqs/[key]"])
      });
    }
  